var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.97 12.031a.75.75 0 0 0 1.06 0l7.001-7a.75.75 0 0 0 0-1.061v-.001a.75.75 0 0 0-1.062 0L6.5 10.44 3.03 6.97a.75.75 0 0 0-1.06 0h-.001a.75.75 0 0 0 0 1.062z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmark;